import Vue from "vue";
import Vuex from "vuex";
import Service from "@/service/api-hr";
import router from "@/router/index";
import store from "@/store/store";

const ServerModule = {
    namespaced: true,
    state: {
        organization : []
    },

    mutations: {
        organization(state, obj) {
            state.organization = obj;
        }
    },

    actions: {
        config({commit}, data) {
            Service.organization('exp', data, {})
                .then((response) => {
                    store.commit("organization/organization", response.data.data)
                }).catch((err) => {
            });
        }
    },

    getters: {
        organization(state, obj) {
            return state.organization;
        },
    },
};

export default ServerModule;
